








import { Component, Vue } from "vue-property-decorator";
import StaffEdit from "@/templates/StaffEdit.vue";
import SaveStaffRequest from "@/usecases/requests/save-staff-request";
import { Company, getOurCompanies } from "@/api/company-api";
import { getServiceRoles } from "@/api/service-api";
import Role from "@/entities/role";
import TaskType from "@/entities/task-type";

@Component({
  components: {
    StaffEdit
  }
})
export default class OurStaffNewPage extends Vue {
  req = new SaveStaffRequest();
  companies: Company[] = [];
  roles: Role[] = [];
  errors: string[] = [];

  get tasktypes(): TaskType[] {
    return this.$store.getters["tasktype/all"];
  }

  async ok() {
    if (this.service.scheduleNotification && !this.req.scheduleNotification) {
      if (confirm("工程表移動チャットが送信されませんがよろしいですか？")) {
        await this.save();
        return;
      } else {
        return;
      }
    } else if (
      !this.service.scheduleNotification &&
      this.req.scheduleNotification
    ) {
      alert("工程表移動チャット機能をONにしてください");
      return;
    }
    // なんかメッセージ出したい
    await this.save();
  }

  cancel() {
    this.$router.push({ name: "our-staff-list" });
  }

  private async created() {
    this.$store.dispatch("tasktype/init");
    this.initCompanies();
    this.initServiceRoles();
    this.req.hasRole = true;
  }

  private async initServiceRoles() {
    this.roles = await getServiceRoles();
  }

  private async initCompanies() {
    this.companies = await getOurCompanies();
  }

  private async save() {
    try {
      await this.$store.dispatch("saveStaff", this.req);
      this.$router.push({ name: "our-staff-list" });
    } catch (e) {
      this.errors = e as [];
      return false;
    }
  }

  get service() {
    return this.$store.state.service;
  }
}
